
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const ShriRenukeshwar=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Shri Renukeshwar Mahadev Mandir</h1>
           <p className="sub-heading">A splendid temple in Renukoot, with one of the largest Nandi idol in India</p>
         </div>
         <div className="description">
         Located in Renukoot, Uttar Pradesh, Shri Renukeshwar Mahadev Mandir is a revered Hindu temple dedicated to Lord Shiva. Known for its tranquil ambiance and spiritual significance, this temple attracts devotees and visitors seeking peace and blessings. Nestled in the heart of nature, it is a perfect destination for both worship and moments of quiet reflection.
         </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Renukeshwar Mandir/mandir.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Renukeshwar Mandir/mandir1.jpeg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Renukeshwar Mandir/mandir2.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Renukeshwar Mandir/mandir3.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Renukeshwar Mandir/mandir4.jpeg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Renukeshwar Mandir/mandir5.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
          
          
         </div>
   
         <BookSection />
       </div>
     );
};